import * as React from 'react';
import { StyleSheet, View, Platform } from 'react-native';
import { translate, translateFirstUpper } from 'secullum-i18n';
import {
  Details,
  DetailsHeader,
  DetailsLine,
  Space,
  Text,
  formatDate,
  isTablet
} from 'secullum-react-native-ui';
import {
  getCorStatus,
  getIconeStatus
} from '../containers/InconsistenciasContainer';
import { getTheme } from '../modules/layout';
import { InconsistenciasDados, InconsistenciasStatus } from '../modules/types';

interface Props {
  inconsistencia: InconsistenciasDados;
}

class InconsistenciaDetalhes extends React.Component<Props> {
  getTextoStatus = () => {
    const { inconsistencia } = this.props;

    switch (inconsistencia!.status) {
      case InconsistenciasStatus.Aceita:
        return translate('Aceito');
      case InconsistenciasStatus.Descartada:
        return translate('Rejeitado');
      case InconsistenciasStatus.Justificada:
        return translateFirstUpper('Justificada');
      default:
        return translate('Aguardando Retorno');
    }
  };

  montarLinhasInformacoes = () => {
    const { inconsistencia } = this.props;

    if (!inconsistencia) {
      return [];
    }

    const linhasInformacoes: Array<DetailsLine> = [
      {
        title: translate('Tipo'),
        value: inconsistencia.tipo
      },
      {
        title: translate('Horas'),
        value: inconsistencia.horas || '-'
      },
      {
        title: translate('Status'),
        value: this.getTextoStatus(),
        icons: [
          {
            name: getIconeStatus(inconsistencia.status),
            color: getCorStatus(inconsistencia.status),
            size: 18
          }
        ]
      },
      {
        render: () =>
          this.renderObservacao(
            translate('Justificativa'),
            inconsistencia.justificativa || '-'
          )
      }
    ];

    return linhasInformacoes;
  };

  renderObservacao = (titulo: string, observacao: string) => {
    return (
      <View style={styles.containerObservacoes}>
        <Text style={styles.textObservacao}>{titulo}</Text>
        <Text style={styles.textObservacao}>{observacao}</Text>
      </View>
    );
  };

  render() {
    const { inconsistencia } = this.props;

    const formatoData =
      Platform.OS === 'web' ? 'eeee, dd/MM/yyyy' : 'dd/MM/yyyy';

    const dataFormatada = formatDate(inconsistencia.data, formatoData);

    return (
      <>
        <DetailsHeader text={dataFormatada} />
        <Space />
        <Details
          title={translate('Informações')}
          lines={this.montarLinhasInformacoes()}
        />
        <Space />
      </>
    );
  }
}

const theme = getTheme();

const styles = StyleSheet.create({
  containerObservacoes: {
    paddingHorizontal: 16,
    paddingVertical: 10
  },
  textObservacao: {
    fontSize: isTablet() ? 18 : 14,
    color: theme.textColor3
  }
});

export default InconsistenciaDetalhes;
